import { render, staticRenderFns } from "./ActivityReports.vue?vue&type=template&id=15f4cc5e&scoped=true"
import script from "./ActivityReports.vue?vue&type=script&lang=js"
export * from "./ActivityReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f4cc5e",
  null
  
)

export default component.exports